export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-fr-76a70d020b9d8a309ecc509e9632cb04.webp";